<template>
  <div class="aside d-column">
    <div class="aside-title d-center fs-lg">
      {{ asideTitle }}
    </div>
    <div class="aside-list">
      <ul class="level-one-ul">
        <li v-for="(item, index) in asideList" :key="item.id">
          <div
            class="level-one-title"
            @click="showChildLi(index, 'li')"
            :class="{ 'font-green': currIndex == index }"
          >
            <img src="../../assets/img/Polygon.svg" />{{ item.title }}
          </div>
          <ul class="level-two-ul" v-show="ifOpen(index)">
            <li
              v-for="(each, i) in item.child"
              :key="each.id"
              @click="activeLi(index, i)"
            >
              <div
                class="level-two-title d-aligncnter"
                :class="{ 'font-green': currIndex2 == i && currIndex == index }"
              >
                <div class="list-circle"></div>
                {{ each.title }}
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'asideTitle',
    'title',
    'asideList',
    'currNav',
    'routeKeepAlive',
    'routeKeepChild',
  ],
  data() {
    return {
      ifDrawer: false, //是否开启菜单抽屉
      indexList: [0],
      currIndex: 0,
      currIndex2: 0,
      //   asideList: [],
      breadTwo: '',
      breadThree: '',
    }
  },
  created() {
    //   this.asideList =
  },
  watch: {
    currNav: {
      handler: function (newVal) {
        this.showChildLi(newVal, 'nav')
      },
      //   deep: true,
    },
  },
  mounted() {
    // this.showChildLiNav(this.currNav)
    this.$nextTick(() => {
      this.showChildLi(this.routeKeepAlive, 'alive')
      this.activeLi(this.routeKeepAlive, this.routeKeepChild)
    })
  },
  //   computed: {
  //     navDataChange: function () {
  //       return this.currNav
  //     },
  //   },
  methods: {
    ifOpen(i) {
      //   console.log('ul是否展开：', this.indexList.indexOf(i))
      if (this.indexList.indexOf(i) > -1) return true
      else return false
    },
    showChildLi(index, str) {
      index = Number(index)
      if (str == 'alive') {
        this.indexList = []
      }
      if (this.ifDrawer) {
        this.indexList = []
      }
      if (this.indexList.indexOf(index) > -1 && str == 'li') {
        this.indexList.splice(this.indexList.indexOf(index), 1)
      } else {
        this.indexList.push(index)
      }
      this.currIndex = index
      this.currIndex2 = 0
      this.breadTwo = this.asideList[index].title
      if (this.asideList[index].child.length > 0) {
        this.breadThree = this.asideList[index].child[0].title
        this.$emit('changeType', this.asideList[index].child[0].showType)
      } else {
        this.breadThree = ''
        this.$emit('changeType', this.asideList[index].showType)
      }
      this.$emit('changeBread', this.breadTwo, this.breadThree)
      if (this.asideList[index].showType == 'video') {
        // let keepindex = 3
        // if (this.asideList[index].title == '教学教材') {
        //   keepindex = 2
        // }
        this.$router.push({
          path: '/video',
          query: {
            one: '体育教学',
            two: this.asideList[index].title,
            three: '',
            path: '/teaching',
            keepalive: 0,
            keepchild: 0,
            path1: '/teaching',
            // oneInfo: { name: item.name, path: item.href },
            // twoInfo: { name: each.title, path: each.href },
            // threeInfo: { name: '', path: '' },
          },
        })
      }
      this.$emit('listIndexChange', index, '-1')
    },

    activeLi(index, i) {
      if (this.asideList[index].child.length > 0) {
        this.currIndex = index
        this.currIndex2 = i
        this.breadTwo = this.asideList[index].title
        this.breadThree = this.asideList[index].child[i].title
        this.$emit('changeBread', this.breadTwo, this.breadThree)
        this.$emit('changeType', this.asideList[index].child[i].showType)
        this.$emit('listIndexChange', index, i)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.aside-list {
  margin-top: -14px;
}
.aside {
  background-color: #f9f9f9;
  width: 280px;
  min-height: 548px;
  margin-bottom: 24px;
  .aside-title {
    width: 100%;
    height: 57px;
    line-height: 57px;
    color: #fff;
    background: url('../../assets/img/titlebg.png') no-repeat;
  }
}
ul {
  height: auto;
}
li {
  list-style: none;
  width: 280px;
  //   height: 38px;
  line-height: 38px;

  margin-top: 2px;
}
.level-one-ul {
  margin-left: -40px;
}
.level-two-ul {
  margin-left: -40px;
  li {
    width: 244px;
    padding-left: 34px;
    margin-top: 2px;
    background-color: #f9f9f9;
    border: 1px solid #fff;
    border-top: 1px solid transparent;
    cursor: pointer;
    user-select: none;
    &:hover {
      border: 1px solid #4da282;
    }
  }
}
.level-one-title {
  cursor: pointer;
  user-select: none;
  border: 1px solid #fff;
  border-top: 1px solid transparent;
  background-color: #f9f9f9;
  &:hover {
    border: 1px solid #4da282;
  }
  img {
    width: 8px;
    height: 8px;
    margin-left: 18px;
    margin-right: 4px;
    transform: rotate(180deg);
  }
}
.level-two-title {
  .list-circle {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #2f2f2f;
    margin-right: 6px;
  }
}
.font-green {
  color: #007a4d;
}
</style>
